module.exports = __webpack_public_path__ + "img/sec2_4_.893caddc.png";